<!-- Dialog: Info -->
@if(view && view.canShow['info']) {
  <p-dialog
    header="Detalle del registro"
    [(visible)]="view.canShow['info']"
    (onShow)="scrollToTop()">

    <div [style.width.vw]="80">
      <app-reactive-form-builder
        [form]="form!"
        [serverUrl]="serverUrl"
        [previousData]="previousData"
        (hideDialog)="view.hide('info')">
      </app-reactive-form-builder>
    </div>
  </p-dialog>
}

<!-- Dialog: Delete -->
@if (view && view.canShow['delete']) {
  <p-dialog
    header="Eliminar registro"
    [(visible)]="view.canShow['delete']"
    (onShow)="scrollToTop()">

    <div [style.width.vw]="80">
      <app-reactive-form-builder
        [form]="form!"
        [serverUrl]="serverUrl"
        [previousData]="previousData"
        [recordHasAssociatedData]="recordHasAssociatedData"
        [getRequest]="getRequest"
        [request]="deleteRequest"
        (hideDialog)="view.hide('delete')">
      </app-reactive-form-builder>
    </div>
  </p-dialog>
}
